import React from 'react';
import { DiscoverProvider } from '../../contexts/DiscoverContext';
import { DiscoverExperience } from '../../components/discover/DiscoverExperience';

/**
 * Discover — university, programme, scholarship and application discovery.
 *
 *   shared records  →  shared state  →  shared logic
 *                              │
 *                    ┌─────────┴─────────┐
 *                 Design A            Design B
 *                (editorial)         (workspace)
 *
 * The page owns nothing but the provider and the presentation switch. Both
 * compositions are complete, both are production-quality, and both read and
 * write the same search, filters, saved items and comparison — so the schedule
 * moving from one to the other changes how Discover looks and nothing about
 * where the student had got to.
 */
export function Discover() {
  return <div className="pb-16" data-id="element-9763" data-mp="247sx07g85h1q">
      <DiscoverProvider data-id="element-9764" data-mp="294jacn0n9yjg">
        <DiscoverExperience data-id="element-9765" data-mp="293zvjf6ajq9n" />
      </DiscoverProvider>
    </div>;
}